import React  from 'react';

const PassengersIcon = () => {
  return <span className="spec-img">
    <svg xmlns="http://www.w3.org/2000/svg" width="20.904" height="28.751" viewBox="0 0 20.904 28.751">
        <g id="passengers" transform="translate(0)">
            <g id="Group_189" data-name="Group 189">
                <path id="Path_154" data-name="Path 154" d="M32.61,18.962a6.862,6.862,0,1,0-10.683-5.7,6.854,6.854,0,0,0,3.033,5.7,10.445,10.445,0,0,0-6.66,9.727v3.66l.429.3c2.308,1.583,6.034,2.506,10.023,2.506s7.715-.923,10.023-2.506l.429-.3v-3.66A10.483,10.483,0,0,0,32.61,18.962Zm4.616,12.331a17.523,17.523,0,0,1-8.474,1.879,17.523,17.523,0,0,1-8.474-1.879v-2.6a8.474,8.474,0,1,1,16.947,0ZM28.752,8.378a4.9,4.9,0,1,1-4.88,4.913A4.89,4.89,0,0,1,28.752,8.378Z" transform="translate(-18.3 -6.4)" fill="#0081ca"/>
            </g>
        </g>
    </svg>
</span>
}

export default PassengersIcon;
